import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20geometric%20background%20with%20overlapping%20circular%20shapes%20in%20deep%20red%20and%20dark%20amber%20tones%2C%20smooth%20gradient%20transitions%20creating%20depth%2C%20modern%20minimalist%20design%20with%20subtle%20texture%2C%20professional%20corporate%20aesthetic%20with%20warm%20energy&width=1800&height=600&seq=cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-foreground-900/85"></div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          准备好开始您的体育在线之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-foreground-400 max-w-xl mx-auto mb-8 leading-relaxed">
          加入开体育在线，畅享500+赛事直播、专业数据分析和实时比分更新。随时随地，体育精彩不间断。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/football"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer transform hover:scale-105"
          >
            立即开始
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-transparent text-background-50 border border-background-50/40 rounded-full font-semibold text-sm whitespace-nowrap hover:bg-background-50/10 transition-all duration-300 cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}